// extracted by mini-css-extract-plugin
export default {"newPasswordContainer":"NewPassword_newPasswordContainer__ZMpzZ","title":"NewPassword_title__Z6pGk","input":"NewPassword_input__qDpKO","button":"NewPassword_button__6VeI4"};